import React from "react";

const Resume = () => {
    return (
        <div id="fh5co-resume" className="fh5co-bg-color">
            <div className="container">
                <div className="row animate-box">
                    <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
                        <h2>My Resume</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-md-offset-0">
                        <ul className="timeline">
                            <li className="timeline-heading text-center animate-box">
                                <div><h3>Work Experience</h3></div>
                            </li>
                            <li className="animate-box timeline-unverted">
                                <div className="timeline-badge"><i className="icon-suitcase"></i></div>
                                <div className="timeline-panel">
                                    <div className="timeline-heading">
                                        <h3 className="timeline-title">Software Developer Intern</h3>
                                        <span className="company">Openstream.ai - May 2024 – August 2024</span>
                                    </div>
                                    <div className="timeline-body">
                                        <p>Improved multi-GPU training pipelines, boosting query accuracy by 30%.</p>
                                    </div>
                                </div>
                            </li>
                            <li className="timeline-inverted animate-box">
                                <div className="timeline-badge"><i className="icon-suitcase"></i></div>
                                <div className="timeline-panel">
                                    <div className="timeline-heading">
                                        <h3 className="timeline-title">Senior Software Engineer</h3>
                                        <span className="company">Samsung Research - June 2019 – July 2023</span>
                                    </div>
                                    <div className="timeline-body">
                                        <p>Built scalable IoT frameworks, developed APIs, and reduced latency to under 1 second.</p>
                                    </div>
                                </div>
                            </li>

                            <li className="timeline-heading text-center animate-box" style={{ marginTop: "30px" }}>
                                <div><h3>Education</h3></div>
                            </li>
                            <li className="timeline-inverted animate-box">
                                <div className="timeline-badge"><i className="icon-graduation-cap"></i></div>
                                <div className="timeline-panel">
                                    <div className="timeline-heading">
                                        <h3 className="timeline-title">Master's Degree</h3>
                                        <span className="company">University of Wisconsin-Madison - 2023-2025</span>
                                    </div>
                                    <div className="timeline-body">
                                        <p>Specializing in distributed systems and machine learning.</p>
                                    </div>
                                </div>
                            </li>
                            <li className="animate-box timeline-unverted">
                                <div className="timeline-badge"><i className="icon-graduation-cap"></i></div>
                                <div className="timeline-panel">
                                    <div className="timeline-heading">
                                        <h3 className="timeline-title">Bachelor's Degree</h3>
                                        <span className="company">Indian Institute of Technology Dhanbad - 2015-2019</span>
                                    </div>
                                    <div className="timeline-body">
                                        <p>Graduated with a degree in Computer Science, focusing on software development.</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resume; 